import React, { useReducer } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import Steps from '../Common/components/Steps';
import { questionnaireReducer, QuestionnaireReducerAction } from '../Common';
import { updateQuestionnaireMutation } from './mutations';
import { GetQuestionnaireResponse, getQuestionnaire } from './queries';
import { CustomBackdrop } from '@blumtechgroup/blum-react-core-components';


interface Props {
  questionnaireId: string;
  handleFinish: () => void;
}

const EditDansFundQuestionnaireComponent = ({
                                              questionnaireId,
                                              handleFinish,
                                            }: Props): React.ReactElement => {
  const [questionnaire, dispatchQuestionnaire] = useReducer(questionnaireReducer, {
    name: '',
    send_to: '',
    questions: [],
  });

  const { loading: questionnaireLoading } = useQuery<GetQuestionnaireResponse>(getQuestionnaire, {
    variables: { id: questionnaireId },
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      dispatchQuestionnaire({
        type: QuestionnaireReducerAction.INIT,
        value: data.dans_fund_questionnaire_by_pk,
      });
    },
  });

  const [updateQuestionnaire, { loading: saving }] = useMutation(updateQuestionnaireMutation, { onCompleted: handleFinish });

  const handleSave = async () => {
    await updateQuestionnaire({
      variables: {
        id: questionnaireId,
        _set: {
          name: questionnaire.name,
          questions: questionnaire.questions,
          send_to: questionnaire.send_to,
        },
      },
    });
  };

  return (
    <>
      <Steps completeLabel="Save" questionnaire={questionnaire}
             dispatch={dispatchQuestionnaire} handleSave={handleSave} />
      {(questionnaireLoading || saving) && <CustomBackdrop label="Loading" />}
    </>
  );
};

export default EditDansFundQuestionnaireComponent;
